import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useState } from 'react';

interface PaginationCountState {
  paginationCount: number;
  setPaginationCount: Dispatch<SetStateAction<number>>;
}

const PaginationCountContext = createContext<PaginationCountState>({
  paginationCount: 1,
  setPaginationCount: () => null,
});

interface Props {
  children: ReactNode;
}

export const PaginationCountProvider = ({ children }: Props) => {
  const [paginationCount, setPaginationCount] = useState(1);

  return (
    <PaginationCountContext.Provider
      value={{
        paginationCount,
        setPaginationCount,
      }}
    >
      {children}
    </PaginationCountContext.Provider>
  );
};
